export enum ELocalStorageKeys {
	accessToken = 'vemo-access-token',
	refreshToken = 'vemo-refresh-token',
	country = 'vemo-country',
}